export const L_STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  NOTICED_CONTENTS: 'noticedContents',
  SMS_PHONE_NUMBER: 'smsPhoneNumber',
  MAIL_ADDRESS: 'mailAddress',
  NEVER_SHOW_WITHDRAWAL_GUIDE: 'neverShowWithdrawalGuide',
  UPSIDER_CREATE_ACCOUNT_STEP: 'upsider-create-account-step',
  UPSIDER_CREATE_ACCOUNT_FORM_DATA: 'upsider-create-account-form-data',
  UPSIDER_OAUTH_CLIENT_PARAMS: 'upsider-oauth-client-params',
  CHALLENGE_SUCCESS_TOKENS: 'challenge-success-tokens',
} as const
